<template>
  <v-container
    id="classesView"
    tag="section"
  >
    <v-overlay class="waitoverlay" :value="busy || contentLibraryLoading">
      <v-progress-circular
        indeterminate
        size="64"
        class="mr-4"
      /> {{ contentLibraryLoading ? 'Loading content library...' : $t('global.loading') }}
    </v-overlay>
    <h1>{{ $t('dashboard.title', [accountName]) }}</h1>
    <v-row v-if="accountExpired">
      <v-col>
        <v-card color="red" class="text-center text-white pt-10">
          <h1>{{ $t('dashboard.account-expired-message') }}</h1>
          <p>{{ $t('dashboard.account-expired-message2') }}</p>
        </v-card>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="4">
        <v-card><v-card-title>{{ $t('dashboard.users') }}</v-card-title><v-card-text><div class="quota" v-html="getUsageQuota('Users')" /></v-card-text></v-card>
      </v-col>
      <v-col cols="12" sm="4">
        <v-card>
          <v-card-title>{{ $t('dashboard.sessions') }}</v-card-title><v-card-text>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <div 
                class="quota" 
                :aria-expanded="false"
                v-bind="attrs" 
                v-on="on" 
                v-html="getUsageQuota('Sessions')"
              />
            </template>
            <span>{{ sessionsCompleted }}</span>
          </v-tooltip>
        </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" sm="4">
        <v-card><v-card-title>{{ $t('dashboard.devices') }}</v-card-title><v-card-text><div class="quota" v-html="getUsageQuota('Devices')" /></v-card-text></v-card>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="8">
        <shortcode-generator v-if="!youraccount" :title="$t('dashboard.generate-code')" action="trial" :account="account">
          <p v-html="$t('dashboard.generate-code-instructions')" />
        </shortcode-generator>
      </v-col>
      <v-col>
        <!-- <v-card v-if="roleSysAdmin">
          <v-card-title>{{ $t('dashboard.adminstration') }}</v-card-title>
          <v-card-text>
            <v-btn color="secondary" @click="refreshStats">
              {{ $t('dashboard.recalculate-stats') }}
            </v-btn>
          </v-card-text>
        </v-card> -->
      </v-col>
    </v-row>
    <v-card>
      <v-card-title class="mb-0">
        <v-row>
          <v-col cols="12" sm="4">
            {{ $t('summary') }}
            <v-spacer />
          </v-col>
          <v-col cols="12" sm="4">
            <date-range-picker @datesChange="datesChanged" />
          </v-col>
          <v-col cols="12" sm="4">
            <v-btn 
              color="success" 
              class="ml-4" 
              :aria-label="$t('dashboard.download-summary')"
              @click="exportAsPdf"
            >
              <v-icon>mdi-download</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-text>
        <v-row v-if="!contentLibraryLoading">
          <v-col>
            <platform-usage id="platformUsage" :start-date="startDate" :end-date="endDate" scope="account" />
          </v-col>
        </v-row>
        <v-row v-if="!contentLibraryLoading">
          <v-col>
            <module-survey-explorer id="successFactors" :start-date="startDate" :end-date="endDate" scope="account" />
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <v-row v-if="!youraccount && !contentLibraryLoading">
      <v-col>
        <user-list
          :title="$t('dashboard.administrators')"
          :roles="adminAssignableRoles"
          :account="account"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>

  import api from '@/helpers/api.js'
  import userList from './UsersList.vue'
  import ModuleSurveyExplorer from './ModuleSurveyExplorer'
  import moment from 'moment'
  import shortcodeGenerator from './ShortcodeGenerator.vue'
  import { Roles } from '@/helpers/users.js'
  import PlatformUsage from './PlatformUsage'
  import { downloadDashboardExportsAsPdf } from '@/helpers/shared.js'
  import DateRangePicker from './DateRangePicker'

  export default {
    name: 'Dashboard', // this is the name of the component

    components: {
      'user-list': userList,
      'module-survey-explorer': ModuleSurveyExplorer,
      'shortcode-generator': shortcodeGenerator,
      'platform-usage': PlatformUsage,
      'date-range-picker': DateRangePicker,
    },

    data: () => ({
      menu: false,
      cards: [
        { id: 1, title: 'Card 1', text: 'This is the first card.' },
        { id: 2, title: 'Card 2', text: 'This is the second card.' },
        { id: 3, title: 'Card 3', text: 'This is the third card.' },
      ],
      startDate: moment().startOf('month').toDate(),
      endDate: moment().endOf('month').toDate(),
      usedSessions: 0,
      accountRecord: undefined,
      totalSessions: 0,
      packageName: '',
      busy: false,
      contentLibraryLoading: false,
    }),

    computed: {
      adminAssignableRoles () {
        // check if reseller account
        const roles = [Roles.COACH, Roles.ADMIN]
        if (this.accountRecord && this.accountRecord.accountType === 'reseller') {
          roles.push(Roles.RESELLER)
        }
        return roles
      },
      dateRangeText () {
        return this.dates.map(x => { return moment(x).format('DD-MM-YYYY') }).join(' - ')
      },
      accountExpired () {
        return false
        /* if (!this.accountRecord || this.accountRecord.status === undefined) return false
        console.log('status = ' + this.accountRecord.status)
        return this.accountRecord.status !== 'active' */
      },
      accountName () {
        if (!this.accountRecord) return 'Loading...'
        return this.accountRecord.displayName
      },
      dataRegion () {
        if (!this.accountRecord) return 'Loading...'
        switch (this.accountRecord.dataRegion) {
          case 'gb':
            return this.$t('dashboard.dataregion-london')
          case 'eu':
            return this.$t('dashboard.dataregion-europe')
          default:
            return this.accountRecord.dataRegion.toUpperCase()
        }
      },
      account () {
        return this.viewingAccount()
      },
      youraccount () {
        return !this.$route.query.account
      },
      roleSysAdmin () {
        return (this.$store.getters.currentUserProfile.user.roles.includes('sysadmin'))
      },
      sessionsCompleted () {
        if (this.accountRecord && this.accountRecord.totalSessionsCompleted && this.accountRecord.totalSessions > 0)
        {
          const rate = this.accountRecord.totalSessionsCompleted / this.accountRecord.totalSessions
          return this.$t('dashboard.completedRatio', [(Math.round(rate * 1000)) / 10])
        }
        return this.$t('dashboard.unknown-completion')
      },
    },

    async mounted () {
      // console.log('dashboard mounted')
      this.packageName = this.$t('dashboard.package-name-standard')

      // Load ContentLibrary first to prevent race conditions
      this.contentLibraryLoading = true
      try {
        if (!this.$store.state.contentLibrary) {
          const contents = await api.getContents()
          this.$store.commit('SET_CONTENT_LIBRARY', contents)
        }
      } catch (error) {
        console.error('Failed to load content library:', error)
      } finally {
        this.contentLibraryLoading = false
      }

      if (this.$route.query.account) {
        this.accountRecord = await api.getAccount(this.account)
      }
      else {
        this.accountRecord = this.$store.getters.currentUserProfile.account
      }
      this.startDate = moment().startOf('month').toDate()
      this.endDate = moment().endOf('month').toDate()
    },

    methods: {
      viewingAccount () {
        if (this.$route.query.account) {
          return this.$route.query.account
        } else {
          return this.$store.getters.currentUserProfile.user.account
        }
      },
      getColumns (card) {
        return {
          sm: 4,
        }
      },
      async exportAsPdf () {
        this.busy = true
        const title = `Usage Report ${moment(this.startDate).format('DD/MM/YYYY')} - ${moment(this.endDate).format('DD/MM/YYYY')}`
        await downloadDashboardExportsAsPdf(title, this.accountName)
        this.busy = false
      },
      async refreshStats () {
        this.busy = true
        try {
          const payload = await api.accountRefreshStats(this.account, {})
          this.accountRecord = { ...this.accountRecord, ...payload }
        } catch (ex) {
          console.error(ex)
        }
        this.busy = false
      },
      async refreshItems () {
        this.busy = true
        this.accountRecord = await api.getAccount(this.$store.getters.currentUserProfile.user.account)
        this.busy = false
      },
      datesChanged (dates) {
        this.startDate = dates[0]
        this.endDate = dates[1]
      },
      getUsageQuota (param) {
        const maxParam = 'max' + param
        const totalParam = 'total' + param
        if (!this.accountRecord) return 'Loading...'
        const text = '<span class="big">' + (this.accountRecord[totalParam] ?? 0) + '</span> / ' + ((this.accountRecord[maxParam] === 0 || this.accountRecord[maxParam] > 900000) ? this.$t('dashboard.usage-unlimited') : this.accountRecord[maxParam])
        return text
      },
    },

  }
</script>

<style>
.quota {
  text-align: center;
  padding-top: 16px;
}

.big {
  font-size: 48px !important;
}
</style>
